import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBN500EAU6RQIyNTVzuawIQpVSsh1R1F1w",
  authDomain: "aiyla-91094.firebaseapp.com",
  projectId: "aiyla-91094",
  storageBucket: "aiyla-91094.firebasestorage.app",
  messagingSenderId: "361236932639",
  appId: "1:361236932639:web:225002c0279cee56b9cd2a",
  measurementId: "G-77TPPVEYHD"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
 